import { hasDailyStock } from '../../admin/modules/GestionCartesAccesEtBienEtre/shared/carteDisplay'

export const buildAmicalCaReservationPayload = (
  carte,
  formValues,
  { date, pax, total, isAcces, amicalClient },
) => {
  const matricule = String(formValues.matricule_fiscal_amical || '').trim()
  const civilite = formValues.civilite_amical || ''
  const telephone = String(formValues.telephone_amical || '').trim()
  const clientName = String(formValues.client_name || '').trim()

  return {
    id_carte: carte.id,
    carte_label: carte.label,
    carte_type: carte.type,
    id_facility: carte.id_facility,
    facility_label: carte.facility_label,
    reservation_date: isAcces
      ? (hasDailyStock(carte) ? date || null : null)
      : date || null,
    reservation_time: null,
    pax: isAcces
      ? (carte.pricing_type === 'per_pax' ? pax : 1)
      : pax,
    price_total: total,
    amount: total,
    client_name: clientName || matricule,
    client_email: amicalClient?.voucherEmail || null,
    client_phone: telephone,
    phone_country_code: '+216',
    client_type: 'b2b',
    payment_method: null,
    status: 'pending',
    channel: 'Amicale',
    billing_partner_id: amicalClient?.id || null,
    billing_client_id: amicalClient?.id || null,
    partner_id: amicalClient?.id || null,
    is_amical: true,
    is_amical_validated: false,
    is_amical_rejected: false,
    civilite_amical: civilite || null,
    matricule_amical: matricule || null,
    telephone_amical: telephone || null,
  }
}

export default buildAmicalCaReservationPayload
